/*
 * @Author: zegel
 * @Date: 2020-11-17 10:10:53
 * @LastEditTime: 2020-12-30 17:01:26
 * @LastEditors: Please set LastEditors
 * @Description: 分享页接口
 * @FilePath: /H5/src/projects/kiss/services/shareBookPage.ts
 */
import request from 'umi-request'
import { apiUrl } from '../utils/url'
import { getEnv, isDevelopment } from '@/utils/utils'

interface bookParams {
  id: string
}

/**
 *
 * @param id 书籍id
 * @param business_id 书籍类型  1-小说  2-听书   3-漫画
 * @returns
 */
export const getBookDataByID = ({
  id,
  business_id = 1
}: {
  id: string
  business_id?: number
}) => {
  return request(`${apiUrl}/api/getH5ShareInfo`, {
    method: 'post',
    data: {
      book_id: id,
      business_id
    }
  })
}
interface IAudio {
  book_id: string
  chapter_id: number
  tone_id: number
}
/** 获取音频 */
export const getAudio = (data: IAudio): Promise<unknown> => {
  return request(`${apiUrl}/api/audio/getH5TrayChapterPlayUrl`, {
    method: 'post',
    data
  })
}

interface IReportParams {
  bookId: string
  randomId: string
  action: 1 | 2
  url: string
}

export const getUserData = ({ uid }: { uid: string }) => {
  return request(`/api/getAuthorPageByH5`, {
    method: 'post',
    data: {
      target_uid: uid
    },
    headers: {
      lang: navigator?.language || 'en'
    }
  })
}

/**
 * 万圣节活动接口
 */
export const getHallowmasData = ({ type }: { type: number }) => {
  return request(`/api/activityBooksList`, {
    method: 'post',
    data: {
      type
    }
  })
}
